<style lang="scss">
.add-visitor-image {
  .visitor-image {
    max-width: 100%;
    max-height: 200px;
    cursor: pointer;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <section class="add-visitor-image" v-if="additionalVisitor">
    <b-alert v-if="additionalVisitor.created_by_prison" class="p-1 d-flex" show variant="danger">
      <div>
        <alert-triangle-icon />
      </div>
      <span class="ml-1">
        This additional participant is an establishment created user - they haven't submitted ID.
      </span>
    </b-alert>

    <div v-else class="row">
      <!-- ID Images -->

      <div
        v-if="imagesReady"
        v-for="imageUrl in imageUrls"
       :key="imageUrl"
       :class="colClass"
       class="d-flex justify-content-center"
      >
        <img
          class="visitor-image"
          :src="imageUrl"
          @click="expandMedia(imageUrl)"
        >
      </div>

      <div class="col-12 d-flex mt-2">
        <b-btn variant="warning" class="mr-1 full-width" v-if="additionalVisitor.assets.id_type === 'Child'"
               :disabled="!canRequestId"
               @click="requestAdditionalId()">
          <span class="fas fa-id-card"></span> Request Additional ID
        </b-btn>

        <b-btn variant="primary" class="full-width" @click="viewMediaSideBySide()"
               :class="additionalVisitor.assets.id_type !== 'Child' ? 'full-width' : ''">
          <span class="fas fa-search"></span> View Side by Side Large
        </b-btn>
      </div>
    </div>

    <b-modal id="modal-expand-media" hide-footer size="xl">
      <full-screen-image-modal v-if="imageToExpand" :image-url="imageToExpand"></full-screen-image-modal>
    </b-modal>

    <b-modal id="modal-expand-media-side" hide-footer size="xl">
      <images-side-by-side-modal :imageUrls="imageUrls"></images-side-by-side-modal>
    </b-modal>
  </section>
</template>

<script>
import {mapState} from 'vuex';
import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';
import FullScreenImageModal from '@/components/modals/FullScreenImageModal.vue';
import ImagesSideBySideModal from '@/components/modals/ImagesSideBySideModal.vue';
import { AlertTriangleIcon } from 'vue-feather-icons'
import { VERIFICATION_STATUS } from '@/constants/status';

export default {
  components: {
    FullScreenImageModal,
    ImagesSideBySideModal,
    AlertTriangleIcon,
  },
  data() {
    return {
      canRequestId: true,
      imagesReady: false,
      imageUrls: [],
      imageToExpand: '',
      colClass: 'col-4',
    }
  },
  computed: {
    ...mapState({
      additionalVisitor: state => state.participants.participant,
      safeguardingStatus: state => state.participants.safeguardingStatus,
    }),
  },
  mounted() {
    this.sortImages()
  },
  methods: {
    sortImages() {
      // Check they are verified
      if (this.additionalVisitor.verification_status === VERIFICATION_STATUS.UN_VERIFIED) {
        this.imagesReady = true;
        return;
      }

      // Check they have assets
      if (!this.additionalVisitor.assets) {
        this.imagesReady = true;
        return;
      }

      this.imageUrls = [];
      const idType = this.additionalVisitor.assets.id_type;
      const under18 = !!this.additionalVisitor.under18;
      const hasBack = !!this.additionalVisitor.assets.identity_picture_back_url;

      switch (idType) {
        case 'Child':
          this.colClass = 'col-12'
          this.imageUrls.push(this.additionalVisitor.assets.profile_picture_url)
          if (hasBack) {
            this.colClass = 'col-6'
            this.imageUrls.push(this.additionalVisitor.assets.identity_picture_back_url)
          }
          break;
        case 'DrivingLicence':
          this.colClass = 'col-6'
          this.imageUrls = [
            this.additionalVisitor.assets.profile_picture_url,
            this.additionalVisitor.assets.identity_picture_url,
          ]
          break;
        case 'Passport':
          this.colClass = 'col-4'
          this.imageUrls = [
            this.additionalVisitor.assets.profile_picture_url,
            this.additionalVisitor.assets.identity_picture_url,
            this.additionalVisitor.assets.identity_picture_back_url,
          ]
          break;
        case 'GovernmentIssuedId':
        default:
          this.colClass = 'col-6'
          this.imageUrls = [
            this.additionalVisitor.assets.profile_picture_url,
            this.additionalVisitor.assets.identity_picture_url,
          ]
          if (!under18) {
            this.colClass = 'col-4'
            this.imageUrls.push(this.additionalVisitor.assets.identity_picture_back_url)
          }
          break;
      }
      this.imagesReady = true;
    },
    expandMedia(imageUrl) {
      this.imageToExpand = imageUrl;
      this.$bvModal.show('modal-expand-media');
    },
    viewMediaSideBySide() {
      this.$bvModal.show('modal-expand-media-side');
    },
    requestAdditionalId() {
      this.$swal({
        title: `Request Additional ID be uploaded for ${this.additionalVisitor.firstname} ${this.additionalVisitor.lastname}?`,
        text: 'If so we will send a notification to the visitor informing them of your request.',
        icon: 'warning',
        buttons: true,
      }).then((willRequestId) => {
        if (willRequestId) {
          AdditionalVisitorsService.requestAdditionalVisitorId(this.additional_visitor_id).then(res => {
            this.canRequestId = false;
            this.$toast.success('A Notification has been sent!', {
              toastClassName: ['toast-std', 'success-toast'],
            });
          }).catch(err => {
            this.$toast.error('Error requesting additional id. Please check your connection, refresh the page and try again.', {
              toastClassName: ['toast-std', 'warning-toast'],
            });
          });
        }
      });
    },
  },
}
</script>
